import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import IntNumberFormatInput from '../../../components/int_number_input_formatter';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { Tooltip, Fade } from '@material-ui/core';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    margin: {
        marginTop: 10,
    },
    rtl: {
        textAlign: 'right',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },

});

class EditCvTipoPartida extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.cvTipoPartida.id ? this.props.cvTipoPartida.id : uuidv4(),
            descr: this.props.cvTipoPartida.descr ? this.props.cvTipoPartida.descr : '',
            divisor: this.props.cvTipoPartida.divisor ? this.props.cvTipoPartida.divisor : 1,
            iGrupoPartida: this.props.cvTipoPartida.iGrupoPartida ? this.props.cvTipoPartida.iGrupoPartida : this.props.grupoPartida[0].id,
            cvGrupoPartidaDescr: this.props.cvTipoPartida.grupoPartida ? this.props.cvTipoPartida.grupoPartida : this.props.grupoPartida[0].descr, // fbp ¿?
        }

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });

    };

    fillSelectOptionList = () => {

        return this.props.grupoPartida.map(gp => {

            return (
                <option key={gp.id} value={gp.id}>{gp.descr}</option>
            );

        });

    };

    handleChangeSelect = event => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iGrupoPartida: value,
            cvGrupoPartidaDescr: this.props.grupoPartida.find(gp => gp.id === value).descr
        });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'descr'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            className={classes.textField}
                            margin="normal"
                            autoFocus
                            value={this.state.descr}
                            onChange={(event) => this.handleValueChange(event, 'descr')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <Tooltip title="Núm de partidas asociado a este tipo" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                id={'divisor'}
                                label={'Divisor'}
                                placeholder={'Divisor'}
                                className={classes.textField}
                                margin="normal"
                                InputProps={{ classes: { input: classes.rtl }, inputComponent: IntNumberFormatInput }}
                                value={this.state.divisor}
                                onChange={(event) => this.handleValueChange(event, 'divisor')}
                            />
                        </Tooltip>
                    </FormControl>
                </div>

                <div className={`${classes.containerPair} ${classes.margin}`}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="grupo-partida-placeholder">
                            Grupo Partida
                    </InputLabel>
                        <Select
                            native
                            value={this.state.iGrupoPartida}
                            onChange={(event) => this.handleChangeSelect(event)}
                        >
                            {this.fillSelectOptionList()}
                        </Select>
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const tipoPartida = {
                            id: this.state.id,
                            descr: this.state.descr,
                            divisor: parseInt(this.state.divisor),
                            cvGrupoPartidaDescr: this.state.cvGrupoPartidaDescr,
                            iGrupoPartida: this.state.iGrupoPartida
                        }


                        if (this.props.checkTipoPartida(tipoPartida)) {

                            this.props.okHandler(tipoPartida);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>
            </div>
        )
    }

};

EditCvTipoPartida.propTypes = {
    cvTipoPartida: PropTypes.object.isRequired,
    checkTipoPartida: PropTypes.func.isRequired,
    grupoPartida: PropTypes.object.isRequired,
    okHandler: PropTypes.func.isRequired,    
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditCvTipoPartida);